import React, { useEffect, useRef, useState } from 'react';
import { Box, ListItem } from '@mui/material';
import { Tooltip } from '@biq/apex-ui';
import {
    isMultilineEllipsisActive,
    styles,
} from './life-graph-filters-helpers';

interface ListItemProps {
    option: string;
    optionProps: any;
    index: number;
    colors: Record<string, string>;
}

export const ChainListItem = ({
    option,
    optionProps,
    index,
    colors,
}: ListItemProps): React.JSX.Element => {
    const textContainerRef = useRef<HTMLDivElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        if (textContainerRef.current) {
            const truncated = isMultilineEllipsisActive(
                textContainerRef.current,
                2
            );
            setIsTruncated(truncated);
        }
    }, [option]);

    return (
        <ListItem key={index} {...optionProps}>
            <Box
                sx={{
                    ...styles.listItemsContainerStyles,
                }}
            >
                <Box
                    sx={{
                        backgroundColor: colors[option],
                        ...styles.colorCodeCircleIconStyles,
                    }}
                />
                <Tooltip
                    title={option}
                    placement='right'
                    disableHoverListener={!isTruncated}
                    disableFocusListener={!isTruncated}
                    disableTouchListener={!isTruncated}
                >
                    <Box
                        ref={textContainerRef}
                        sx={{
                            ...styles.ellipsifyListItemTextStyles,
                        }}
                    >
                        {option}
                    </Box>
                </Tooltip>
            </Box>
        </ListItem>
    );
};
